import api from './api';

export const formulaService = {
  // Dashboard & Metrics
  getDashboardStats: async () => {
    const response = await api.get('/formulas/dashboard');
    return response.data?.data;
  },

  // Formula List with filters & pagination
  getFormulas: async (params) => {
    const response = await api.get('/formulas', { params });
    return response.data?.data;
  },

  // Detail
  getFormulaById: async (id) => {
    const response = await api.get(`/formulas/${id}`);
    return response.data?.data;
  },

  // Create
  createFormula: async (payload) => {
    const response = await api.post('/formulas', payload);
    return response.data?.data;
  },

  // Update
  updateFormula: async (id, payload) => {
    const response = await api.put(`/formulas/${id}`, payload);
    return response.data?.data;
  },

  // Activate / Deactivate
  activateFormula: async (id) => {
    const response = await api.post(`/formulas/${id}/activate`);
    return response.data;
  },

  deactivateFormula: async (id, reason) => {
    const response = await api.post(`/formulas/${id}/deactivate`, { reason });
    return response.data;
  },

  // Version History & Audit Trail
  getVersions: async (id) => {
    const response = await api.get(`/formulas/${id}/versions`);
    return response.data?.data;
  },

  getAuditHistory: async (id) => {
    const response = await api.get(`/formulas/${id}/audit`);
    return response.data?.data;
  },

  // Impact Analysis
  getImpactAnalysis: async (id, targetObsId) => {
    const response = await api.get(`/formulas/${id}/impact`, {
      params: { targetObsId }
    });
    return response.data?.data;
  },

  // Live Test Simulation Engine
  testFormula: async (payload) => {
    const response = await api.post('/formulas/test', payload);
    return response.data?.data;
  },

  // Syntax & Variable Validation
  validateFormula: async (payload) => {
    const response = await api.post('/formulas/validate', payload);
    return response.data?.data;
  }
};

export default formulaService;
